import { autoMount } from '../../../utils/autoMount';
import { HotEvents } from '../../../components/organisms/hotEvents';

autoMount({ HotEvents });
